import get from 'lodash/get';
import VALID_COLUMNS from '../../Screens/Contextualization/Manage/components/CustomActionBar/components/ExportCSV/constants';

const escapeCsvValue = (value = '') => {
  const normalizedValue = value === null || value === undefined ? '' : String(value);
  if (!/[",\n\r]/.test(normalizedValue)) return normalizedValue;
  return `"${normalizedValue.replace(/"/g, '""')}"`;
};

const stringifyCsvValue = (value) => {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) return value.map(stringifyCsvValue).filter((item) => item !== '').join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return value;
};

const getServiceLabel = (service = {}) => {
  if (!service || typeof service !== 'object') return service;
  const name = get(service, 'name', '');
  const ports = get(service, 'ports', '');
  const protocol = get(service, 'protocol', '');
  if (!name) return stringifyCsvValue(service);
  if (!ports && !protocol) return name;
  return `(${ports}/${protocol}) ${name}`;
};

const getRiskLabel = (risk = {}) => {
  if (!risk || typeof risk !== 'object') return risk;
  return get(risk, 'score', stringifyCsvValue(risk));
};

const CSV_COLUMN_GETTERS = {
  date: (vuln) => get(vuln, 'date', get(vuln, 'create_date', '')),
  risk: (vuln) => getRiskLabel(get(vuln, 'risk', '')),
  service: (vuln) => getServiceLabel(get(vuln, 'service', '')),
  target: (vuln) => get(vuln, 'target', get(vuln, 'asset', '')),
  tool: (vuln) => get(vuln, 'tool', get(vuln, 'metadata.tool', '')),
  update_date: (vuln) => get(vuln, 'metadata.update_time', get(vuln, 'update_date', ''))
};

const getExportCsvValue = (vuln, column) => {
  const value = CSV_COLUMN_GETTERS[column] ? CSV_COLUMN_GETTERS[column](vuln) : get(vuln, column, '');
  return stringifyCsvValue(value);
};

export const getExportCsvColumns = (fields = {}, validColumns = VALID_COLUMNS) => {
  return Object.keys(fields)
    .filter((field) => get(fields, `${field}.visible`, false) && validColumns[field])
    .sort((a, b) => {
      const aOrder = get(fields, `${a}.order`, 0);
      const bOrder = get(fields, `${b}.order`, 0);
      return aOrder - bOrder;
    })
    .map((field) => validColumns[field]);
};

export const buildEmptyExportCsv = (columns = []) => `${columns.map(escapeCsvValue).join(',')}\n`;

export const buildExportCsv = (columns = [], vulns = []) => {
  const header = columns.map(escapeCsvValue).join(',');
  const rows = vulns.map((vuln) => columns
    .map((column) => escapeCsvValue(getExportCsvValue(vuln, column)))
    .join(','));

  return `${[header, ...rows].join('\n')}\n`;
};
